import Vue from "vue";
import { WhitelabelField, WhitelabelTextFieldMixin } from "@/components/whitelabel/whitelabel";
import Info from "@/components/Info.vue";
export default Vue.extend({
    name: "WhitelabelFont",
    mixins: [WhitelabelField, WhitelabelTextFieldMixin],
    components: { Info }
});
